import { render, staticRenderFns } from "./otorisasiv2.vue?vue&type=template&id=3cef97e6&scoped=true"
import script from "./otorisasiv2.vue?vue&type=script&lang=js"
export * from "./otorisasiv2.vue?vue&type=script&lang=js"
import style0 from "./otorisasiv2.vue?vue&type=style&index=0&id=3cef97e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cef97e6",
  null
  
)

export default component.exports